import { ReactNode } from 'react'
import { Header } from './Header'
import { ToastContainer } from '../toast/ToastContainer'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div id="app">
      <Header />
      <main>
        {children}
      </main>
      <ToastContainer />
    </div>
  )
}
